import styled from 'styled-components';
import {
  DASHBOARD_GRID_COLUMNS,
  DASHBOARD_GRID_GAP,
  DASHBOARD_MIN_COLUMN_WIDTH,
  DASHBOARD_ROW_HEIGHT,
} from '../../../pages/Home/dashboardWidgets';

const GRID_MIN_WIDTH = DASHBOARD_GRID_COLUMNS * DASHBOARD_MIN_COLUMN_WIDTH
  + (DASHBOARD_GRID_COLUMNS - 1) * DASHBOARD_GRID_GAP;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${DASHBOARD_GRID_COLUMNS}, minmax(${DASHBOARD_MIN_COLUMN_WIDTH}px, 1fr));
  grid-auto-rows: ${DASHBOARD_ROW_HEIGHT}px;
  gap: ${DASHBOARD_GRID_GAP}px;
  min-width: ${GRID_MIN_WIDTH}px;
`;

const WidgetSlot = styled.div`
  position: relative;
  min-width: 0;
  height: 100%;
  border-radius: 12px;
  transition: opacity 0.2s ease, box-shadow 0.2s ease;

  &.with-surface {
    background: ${(props) => props.theme.colors.widget_background};
    overflow: hidden;
  }

  &.move-active {
    cursor: grab;
    touch-action: none;
    box-shadow: 0 0 0 2px ${(props) => props.theme.colors.main_cta};
  }

  &.dragging {
    cursor: grabbing;
    opacity: 0.75;
  }

  .external-widget-menu {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 3;
  }

  .move-instruction {
    position: absolute;
    right: 12px;
    bottom: 12px;
    z-index: 3;
    padding: 6px 10px;
    border-radius: 6px;
    background: ${(props) => props.theme.colors.widget_background};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    color: ${(props) => props.theme.colors.text};
    font-family: ManropeBold, sans-serif;
    font-size: 11px;
    pointer-events: none;
  }
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  border: 1px dashed ${(props) => props.theme.colors.outline};
  border-radius: 12px;
  color: ${(props) => props.theme.colors.inactive};
`;

export default { Grid, WidgetSlot, EmptyState };
